<template>
    <div>
        <el-table :data="tableData" size="small" style="width: 100%" v-loading="tableLoading" 
            element-loading-text="加载中，请稍后" element-loading-spinner="el-icon-loading" ref="tableComponentRef" :border="isBorder"
            :row-key="rowKey && rowKey ? rowKey : ''"
            empty-text="暂无数据" @current-change="tableEvent" :class="tableClassName">
            <template v-for="(element, index) in tableHeader">
                <el-table-column v-if="element.isShow !== false" :label="element.label" 
                    :min-width="element.minWidth ? element.minWidth : ''" 
                    :width="element.width ? element.width : ''"
                    :show-overflow-tooltip="element.showOverflowTooltip" 
                    :fixed="element.fixed && element.fixed" 
                    :align="element.align ? element.align : 'left'" 
                    :key="'tableHeader' + index" >
                    <template slot-scope="scope">
                        <span>{{ element.isShow }}</span>
                        <template v-if="slotName.includes(element.labelField)">
                            <slot :name="element.labelField" :rowData="scope.row" :index='scope.$index'></slot>
                        </template>
                        <template v-else>
                            {{ scope.row[element.labelField] | isParamEmptyFilters }}
                        </template>
                    </template>
                </el-table-column>
            </template>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'tableComponent',
    props: {
        rowKey: { type: String, default: () => { return 'id' } },
        isBorder: { type: Boolean, default: () => { return false } },
        tableClassName: { type: String, default: () => { return '' } },
        tableData: { type: Array, default: () => { return [] } },
        tableLoading: { type: Boolean, default: () => { return false } },
        tableHeader: { type: Array, default: () => { return [] } }
    },
    data() {
        return {
            slotName: ['handler', 'handlerTime', 'handlerSwitch', 'handleTag', 'handleTag2', 'handleTag3', 'handleLink']
        }
    },
    watch: {
        rowKey: {
            deep: true,
            handler(newVal, oldVal) {
                this.rowKey = oldVal !== newVal ? newVal : oldVal;
            },
            immediate: true
        },
        tableData: {
            deep: true,
            handler(newVal, oldVal) {
                this.tableData = oldVal !== newVal ? newVal : oldVal;
            },
            immediate: true
        },
        tableLoading: {
            deep: true,
            handler(newVal, oldVal) {
                this.tableLoading = oldVal !== newVal ? newVal : oldVal;
            },
            immediate: true
        }
    },
    methods: {
        tableEvent(item) {
            this.$emit('tableComponentEvent', item);
        }
    },
    filters: {
        isParamEmptyFilters(value) {
            let emptyValue = [null, undefined, ''];
            if (emptyValue.indexOf(value) !== -1) {
                return '无'
            } else {
                return value
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/TableComponent/TableComponent.vue